'use client';
import dynamic from 'next/dynamic';
import { memo, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Modal } from '~components/Modals/Base';
import { useIsEmailConfirmRequired } from '~features/tags';
import { emailConfirmActions } from '~store/email-confirm';

import { useEmailConfirmModal } from '../../hooks/useEmailConfirmModal';
import type { ActiveModal } from '../../model/types';
import { modalStyle } from './styles';

const Content = dynamic(
	() => import('./dynamicContent').then((mod) => mod.Content),
	{
		ssr: false,
	}
);

export const EmailConfirmModal = memo(() => {
	const dispatch = useDispatch();
	const { isOpened, open, close } = useEmailConfirmModal();
	const [isRequired] = useIsEmailConfirmRequired();

	const [activeModal, setActiveModal] = useState<ActiveModal>('confirm');

	useEffect(() => {
		if (isRequired) {
			// sent during sign up
			dispatch(emailConfirmActions.setLastSent());
			setActiveModal('sent');
			open();
		}
	}, [isRequired, dispatch, open]);

	if (process.env.NEXT_PUBLIC_HIDE_EMAIL_CONFIRM) {
		return null;
	}
	return (
		<Modal
			open={isOpened}
			locked={isRequired}
			className={modalStyle}
			onClose={close}
		>
			<Content
				activeModal={activeModal}
				setActiveModal={setActiveModal}
				isRequired={isRequired}
				open={open}
			/>
		</Modal>
	);
});

EmailConfirmModal.displayName = 'EmailConfirmModal';
